import { render, staticRenderFns } from "./FinancesDashboard.vue?vue&type=template&id=5fac3180&"
import script from "./FinancesDashboard.vue?vue&type=script&lang=js&"
export * from "./FinancesDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports